export const vi = {
  brand: {
    name: 'Mộc',
    tagline: 'Sàn bất động sản',
  },
  menu: {
    windowsOpen: '{count} cửa sổ đang mở',
    langVi: 'Tiếng Việt',
    langEn: 'English',
  },
  apps: {
    market: 'Thị trường',
    compare: 'So sánh',
    manage: 'Quản lý tin đăng',
    manageShort: 'Quản lý',
    loan: 'Tính vay',
    account: 'Tài khoản',
  },
  market: {
    buy: 'Mua bán',
    rent: 'Cho thuê',
    searchPlaceholder: 'Tìm theo địa chỉ, dự án, từ khoá...',
    allProvinces: 'Tất cả tỉnh thành',
    allDistricts: 'Tất cả quận huyện',
    allTypes: 'Tất cả loại hình',
    filters: 'Bộ lọc',
    reset: 'Đặt lại',
    sort: 'Sắp xếp',
    sortNewest: 'Mới nhất',
    sortPriceAsc: 'Giá thấp → cao',
    sortPriceDesc: 'Giá cao → thấp',
    sortAreaDesc: 'Diện tích lớn nhất',
    sortPriceM2Asc: 'Giá / m² thấp nhất',
    resultsCount: '{count} bất động sản',
    noResults: 'Không tìm thấy bất động sản phù hợp',
    clearFilters: 'Xoá bộ lọc',
    only360: 'Chỉ tin có ảnh 360° / VR',
    onlyVerified: 'Chỉ tin đã kiểm định',
    bedrooms: 'Số phòng ngủ',
    priceRange: 'Khoảng giá',
    areaRange: 'Diện tích tối thiểu',
    amenities: 'Tiện ích nổi bật',
    save: 'Lưu tin',
    saved: 'Đã lưu',
    compare: 'So sánh',
    contact: 'Liên hệ',
    details: 'Xem chi tiết',
  },
  common: {
    close: 'Đóng',
    cancel: 'Huỷ',
    save: 'Lưu',
    copied: 'Đã sao chép liên kết',
    search: 'Tìm kiếm',
  },
}

export type Dict = typeof vi
